import { Page } from '.';

export class NavItem {
  name: string;
  description: string;
  id: number;
  position: number;
  createdAt: string;
  updatedAt: string;
  icon: string;

  targetID: string;
  targetPage: Page;
  firebaseUrl: string = '';

  testID: string = '';

  constructor(json: any) {
    this.name = json.name || '';
    this.description = json.description || '';
    this.id = json.id || '';
    this.position = json.position || 0;
    this.createdAt = json.created_at || '';
    this.updatedAt = json.updated_at || '';
    this.firebaseUrl = json.firebase_url || '';
    this.targetID = json.target || json.targetID;

    this.firebaseUrl = '/' + json.$key;

    this.generateDynamicId();
  }

  toFirebaseObject() : any {
    let obj: any = {};
    if (this.name) obj.name = this.name;
    if (this.description) obj.description = this.description;
    if (this.id) obj.id = this.id;
    if (this.position) obj.position = this.position;
    if (this.createdAt) obj.created_at = this.createdAt;
    if (this.updatedAt) obj.updated_at = this.updatedAt;
    if (this.firebaseUrl) obj.firebase_url = this.firebaseUrl;
    if (this.targetID) obj.target = this.targetID;
    return obj;
  }

  generateDynamicId() {
    let validId = this.name;
    validId = validId.replace(/\s+/g, '-');
    validId = validId.replace(/[^a-z0-9\-_\.]|^[^a-z0-9]+/gi, '');
    this.testID = 'nav-' + validId;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/nav-item.model.ts